import React, { useRef, useEffect, useCallback, useState} from 'react';
import Group from "./Group.js"
import {connect} from 'react-redux';
import '../../StepGroups.scss';

const TrackStepGroups = ({trackSteps, track, stepsGroupMode, scale=1}) => { 
    let ref = useRef(undefined);
    if (!stepsGroupMode) { return []; }

    let groups = track.pattern.getAllGroups();
    return (
        <div
          ref={ref} 
          className="track-step-groups">
          {groups.map(g => <Group
                             scale={scale}
                             container={ref} key={g.id} trackSteps={trackSteps} group={g} track={track}/>)}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      stepsGroupMode: state.groups.stepsGroupMode,
      trackSteps: state.tracks.trackSteps[props.track.trackNumber],
      stepGroups: state.steps.stepGroups
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackStepGroups);
